import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "container flex gap-2 justify-between max-w-5xl mx-auto overflow-x-auto p-5 pb-3 xl:flex-row" }
const _hoisted_3 = { class: "flex gap-2 items-center" }
const _hoisted_4 = { class: "h1 capitalize" }
const _hoisted_5 = { class: "container flex flex-col gap-2 justify-between max-w-5xl mx-auto overflow-x-auto px-5 py-3 xl:flex-row" }
const _hoisted_6 = { class: "flex gap-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  width: "6",
  height: "10",
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "0.707107",
    x2: "0.707106",
    y2: "5",
    stroke: "#222B45",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "0.707107",
    y1: "5",
    x2: "5",
    y2: "9.29289",
    stroke: "#222B45",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Back", -1)
const _hoisted_9 = { class: "flex gap-2 items-center justify-center" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = ["checked"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "isActive",
  id: "toggle",
  class: "bg-[#D1E8B4] cursor-pointer h-5 relative rounded-full w-9"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "form-check" })
  ])
], -1)
const _hoisted_14 = { class: "flex gap-2 items-center" }
const _hoisted_15 = { class: "form-check" }
const _hoisted_16 = ["checked"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text w-max" }, "Auto Open/Close", -1)
const _hoisted_18 = { class: "flex gap-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "15",
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.69061 6.34949V11.4C1.69061 12.0896 1.9817 12.7509 2.49977 13.2385C3.01784 13.7261 3.72045 14 4.45311 14H9.97812C10.7108 14 11.4134 13.7261 11.9315 13.2385C12.4496 12.7509 12.7406 12.0896 12.7406 11.4V6.34949",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 2.95C1 2.43283 1.21832 1.93683 1.60687 1.57113C1.99542 1.20543 2.52238 1 3.07188 1H11.3594C11.9089 1 12.4359 1.20543 12.8244 1.57113C13.213 1.93683 13.4313 2.43283 13.4313 2.95",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.4312 4.89999C13.4312 5.41717 13.213 5.91317 12.8244 6.27886C12.4358 6.64456 11.9088 6.84999 11.3594 6.84999C10.8099 6.84999 10.2829 6.64456 9.89434 6.27886C9.50579 5.91317 9.28748 5.41717 9.28748 4.89999",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.28749 4.89999C9.28749 5.41717 9.06922 5.91317 8.68066 6.27886C8.29211 6.64456 7.76511 6.84999 7.21561 6.84999C6.66612 6.84999 6.13916 6.64456 5.75061 6.27886C5.36205 5.91317 5.14374 5.41717 5.14374 4.89999",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.14375 4.89999C5.14375 5.41717 4.92548 5.91317 4.53693 6.27886C4.14837 6.64456 3.62137 6.84999 3.07188 6.84999C2.52238 6.84999 1.99542 6.64456 1.60687 6.27886C1.21832 5.91317 1 5.41717 1 4.89999",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.4313 2.95V4.9",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.28748 2.95V4.9",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.14374 2.95V4.9",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 2.95V4.9",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.21564 9.45001V12.05",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Edit Store", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.52187 3.23006L12.2649 3.72403C12.5344 3.77113 12.7919 3.87095 13.0227 4.0177C13.2535 4.16445 13.4532 4.35528 13.6101 4.57928C13.7671 4.80328 13.8784 5.05602 13.9375 5.32308C13.9967 5.59013 14.0026 5.86625 13.955 6.13559L12.8694 12.2782C12.8231 12.5474 12.724 12.8048 12.5779 13.0355C12.4318 13.2663 12.2416 13.466 12.0181 13.623C11.7946 13.7801 11.5423 13.8914 11.2757 13.9507C11.009 14.0099 10.7333 14.0159 10.4644 13.9682L5.34229 13.0647C5.07258 13.0173 4.81487 12.9171 4.58397 12.7699C4.35307 12.6226 4.15352 12.4313 3.99677 12.2067",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.01954 1.03302C7.28812 0.984433 7.56367 0.989507 7.83027 1.04797C8.09687 1.10644 8.34924 1.21713 8.57284 1.37365C8.79644 1.53017 8.98684 1.72942 9.13303 1.95991C9.27922 2.1904 9.37831 2.44754 9.42459 2.71653L10.5101 8.86565C10.5587 9.13423 10.5536 9.40978 10.4951 9.67638C10.4367 9.94299 10.326 10.1954 10.1695 10.419C10.0129 10.6426 9.81369 10.833 9.58321 10.9791C9.35272 11.1253 9.09556 11.2244 8.82657 11.2707L3.70447 12.1742C3.16144 12.2706 2.60235 12.1475 2.15012 11.8318C1.69789 11.5161 1.38957 11.0337 1.29293 10.4907L1.09143 9.33364",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.09805 9.33363C0.783997 7.44783 1.23121 5.51451 2.34148 3.95818C3.45175 2.40185 5.1343 1.34977 7.01965 1.033V1.033",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.04559 9.03465C0.714079 6.3241 3.64563 8.00761 5.00416 6.04457C6.36268 4.08154 4.35415 1.49451 7.0257 1.033",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "Products", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "15",
  viewBox: "0 0 16 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.40948 4.29551V11.181C2.40948 11.9286 2.70653 12.6457 3.2352 13.1743C3.76387 13.703 4.48085 14 5.2285 14H10.8665C11.6142 14 12.3312 13.703 12.8599 13.1743C13.3886 12.6457 13.6856 11.9286 13.6856 11.181V4.2885",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.0951 3.16848C15.0951 2.59336 14.7981 2.0418 14.2694 1.63513C13.7408 1.22846 13.0237 1 12.2761 1H3.81902C3.07137 1 2.35438 1.22846 1.82571 1.63513C1.29704 2.0418 1 2.59336 1 3.16848C1 3.45603 1.14852 3.73183 1.41286 3.93516C1.67719 4.1385 2.03568 4.25271 2.40951 4.25271H13.6856C14.0594 4.25271 14.4179 4.1385 14.6823 3.93516C14.9466 3.73183 15.0951 3.45603 15.0951 3.16848Z",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Tables", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "15",
  viewBox: "0 0 16 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.97949 7.5C8.77441 7.5 10.2295 6.04492 10.2295 4.25C10.2295 2.45507 8.77441 1 6.97949 1C5.18457 1 3.72949 2.45507 3.72949 4.25C3.72949 6.04492 5.18457 7.5 6.97949 7.5Z",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 14C1.37074 12.7216 2.13616 11.5932 3.18685 10.776C4.23753 9.95876 5.51968 9.49467 6.85 9.45001C9.528 9.45001 11.8095 11.3415 12.7 14",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.9333 2.58604C12.4285 2.83989 12.8291 3.24587 13.0764 3.74433C13.3236 4.24279 13.4045 4.8074 13.307 5.35521C13.2095 5.90302 12.9389 6.40508 12.5348 6.78763C12.1308 7.17019 11.6146 7.41304 11.0623 7.48048",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.6082 9.17055C12.4752 9.3915 13.2706 9.83241 13.9174 10.4507C14.5641 11.069 15.0404 11.8438 15.3001 12.7",
    stroke: "#222B45",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Members", -1)
const _hoisted_27 = { class: "container flex flex-col gap-2 max-w-5xl mx-auto overflow-x-auto p-5" }
const _hoisted_28 = { class: "box-details flex flex-col gap-4" }
const _hoisted_29 = { class: "flex flex-col gap-6 w-full md:flex-row" }
const _hoisted_30 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_31 = { class: "flex justify-between" }
const _hoisted_32 = { class: "h2 mr-4 capitalize" }
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"flex gap-1 items-center\"><svg id=\"edit\" width=\"13\" height=\"13\" viewBox=\"0 0 13 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.6198 0.243237C6.54965 0.094295 6.40489 0 6.24638 0C6.08787 0 5.9431 0.094295 5.87295 0.243237L4.16821 3.86273L0.356592 4.44272C0.199722 4.46659 0.0693902 4.58172 0.0203993 4.73968C-0.0285915 4.89765 0.0122563 5.07106 0.125767 5.187L2.88396 8.00423L2.23266 11.9826C2.20586 12.1463 2.27009 12.3118 2.39832 12.4094C2.52656 12.507 2.69658 12.5199 2.83688 12.4426L6.24638 10.5643L9.65587 12.4426C9.79618 12.5199 9.96619 12.507 10.0944 12.4094C10.2227 12.3118 10.2869 12.1463 10.2601 11.9826L9.60879 8.00423L12.367 5.187C12.4805 5.07106 12.5213 4.89765 12.4724 4.73968C12.4234 4.58172 12.293 4.46659 12.1362 4.44272L8.32454 3.86273L6.6198 0.243237Z\" fill=\"#E9A71D\"></path><path d=\"M6.6198 0.243237C6.54965 0.094295 6.40489 0 6.24638 0C6.08787 0 5.9431 0.094295 5.87295 0.243237L4.16821 3.86273L0.356592 4.44272C0.199722 4.46659 0.0693902 4.58172 0.0203993 4.73968C-0.0285915 4.89765 0.0122563 5.07106 0.125767 5.187L2.88396 8.00423L2.23266 11.9826C2.20586 12.1463 2.27009 12.3118 2.39832 12.4094C2.52656 12.507 2.69658 12.5199 2.83688 12.4426L6.24638 10.5643L9.65587 12.4426C9.79618 12.5199 9.96619 12.507 10.0944 12.4094C10.2227 12.3118 10.2869 12.1463 10.2601 11.9826L9.60879 8.00423L12.367 5.187C12.4805 5.07106 12.5213 4.89765 12.4724 4.73968C12.4234 4.58172 12.293 4.46659 12.1362 4.44272L8.32454 3.86273L6.6198 0.243237Z\" fill=\"#E9A71D\"></path></svg><span class=\"text-title\">3.6</span><p class=\"text-mini\">(9 Reviews)</p></div>", 1)
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "flex justify-between" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "qr-code" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_40 = { class: "flex flex-col" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "Working Time", -1)
const _hoisted_42 = { class: "flex justify-between" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Monday", -1)
const _hoisted_44 = {
  key: 0,
  class: "text"
}
const _hoisted_45 = {
  key: 1,
  class: "text"
}
const _hoisted_46 = { class: "flex justify-between" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Tuesday", -1)
const _hoisted_48 = {
  key: 0,
  class: "text"
}
const _hoisted_49 = {
  key: 1,
  class: "text"
}
const _hoisted_50 = { class: "flex justify-between" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Wednesday", -1)
const _hoisted_52 = {
  key: 0,
  class: "text"
}
const _hoisted_53 = {
  key: 1,
  class: "text"
}
const _hoisted_54 = { class: "flex justify-between" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Thursday", -1)
const _hoisted_56 = {
  key: 0,
  class: "text"
}
const _hoisted_57 = {
  key: 1,
  class: "text"
}
const _hoisted_58 = { class: "flex justify-between" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Friday", -1)
const _hoisted_60 = {
  key: 0,
  class: "text"
}
const _hoisted_61 = {
  key: 1,
  class: "text"
}
const _hoisted_62 = { class: "flex justify-between" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Saturday", -1)
const _hoisted_64 = {
  key: 0,
  class: "text"
}
const _hoisted_65 = {
  key: 1,
  class: "text"
}
const _hoisted_66 = { class: "flex justify-between" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Sunday", -1)
const _hoisted_68 = {
  key: 0,
  class: "text"
}
const _hoisted_69 = {
  key: 1,
  class: "text"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "Contact", -1)
const _hoisted_71 = {
  key: 0,
  class: "text"
}
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" No address")
const _hoisted_73 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_75 = {
  key: 1,
  class: "text"
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "button-nav-admin button-view-map" }, "View map", -1)
const _hoisted_80 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "Delivery", -1)
const _hoisted_82 = { class: "flex justify-between" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Minimal Order", -1)
const _hoisted_84 = { class: "text" }
const _hoisted_85 = { class: "flex justify-between" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Delivery Cost", -1)
const _hoisted_87 = { class: "text" }
const _hoisted_88 = { class: "flex justify-between" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Delivery Time", -1)
const _hoisted_90 = { class: "text" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "Delivery Types", -1)
const _hoisted_92 = { class: "text capitalize" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "Category", -1)
const _hoisted_94 = { class: "text" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "Subcategories", -1)
const _hoisted_96 = { class: "flex flex-col gap-2 w-full sm:flex-row 2xl:flex-row" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "Information:", -1)
const _hoisted_98 = { class: "text" }
const _hoisted_99 = { class: "box-details flex flex-col gap-4" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-4 items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-1/2" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "ADMINISTRATION")
  ])
], -1)
const _hoisted_101 = { class: "flex flex-col gap-2 items-center justify-between sm:flex-row" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Status ", -1)
const _hoisted_103 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Delivery Comission", -1)
const _hoisted_105 = ["value"]
const _hoisted_106 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Pickup Comission", -1)
const _hoisted_108 = ["value"]
const _hoisted_109 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "In Store Comission", -1)
const _hoisted_111 = ["value"]
const _hoisted_112 = /*#__PURE__*/_createElementVNode("span", null, "Update", -1)
const _hoisted_113 = [
  _hoisted_112
]

import { baseAPI } from "@/plugins/axios";
import { onMounted, onBeforeMount, ref, computed, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { plainToClass } from "class-transformer";
import vselect from "../../../../components/v-select/index.vue";
import AutoComplete from "@/components/AutoComplete.vue";
import action from "../../../../components/base/action/index.vue";
import StoreAutocomplete from "../../../../components/shared/store/autocomplete/index.vue";
import { Helpers } from "@/helper";
import { config } from "../../../../plugins/config";
import { QrType, StoreStatus, UserRoleWithOwner } from "@/globals/enums";
import {
  StoreEntity,
  StoreFilterEntity,
  storeservice,
  PaginationEntity,
  StoreUserEntity,
  userservice,
  UserFilterEntity,
  CategoryEntity,
  categoryservice,
  CategoryFilterEntity,
} from "@/utils";
import { store } from "@/store";
import { notify } from "@kyvg/vue3-notification";
import { getSignedUrl } from "@/services/shared/image.service";
import Loader from "@/components/shared/loading/Loader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreDetailView',
  setup(__props) {

const stores = ref([] as Array<StoreEntity>);
const showActionTab = ref();
const datas = ref([]);
const route = useRoute();
const router = useRouter();
const query = [] as any;
const Stores = ref() as any;
const Categories = ref() as any;
const Owners = ref() as any;
const StoreFilter = new StoreFilterEntity(query);
const statusQuery = ref("");
const selectedStatus = ref<any[]>([]);
const storeDetails = ref<any>();
const storeSubCategories = ref<any>([]);
const commission = reactive<any>({
  delivery: 0,
  pickup: 0,
  inStore: 0,
});
const storeStatus = ref({
  id: "verified",
  value: "Verified",
});
const loading = ref(false);
const storeQrCode = ref("") as any;
const storeStatuses = Helpers.enumToItems(StoreStatus);
const appUrl = process.env.VUE_APP_API_URL;

// const commission = ref<any>({});

const IsActive = ref();
(async () => {
  loading.value = true;
  const [{ data: storeData }, { data: categories }, { data: owner }] =
    await Promise.all([
      storeservice.getAll(StoreFilter),
      categoryservice.getAll(new CategoryFilterEntity({ Limit: 100000 })),
      userservice.getAll(
        new UserFilterEntity({
          Limit: 100000,
          Role: UserRoleWithOwner.OWNER,
        })
      ),
    ]);
  Stores.value = storeData?.data;
  Categories.value = categories.data;
  Owners.value = owner?.data
    ?.filter((data) => data !== null)
    .map((data: any) => {
      return { ...data, name: data.firstName + " " + data.lastName };
    });

  store.state.stores = [
    ...storeData?.data,
    { categories: categories.data, owners: owner?.data },
  ];
})();
loading.value = false;

stores.value = datas.value;
const StoreStatuses = computed(() => {
  return Helpers.enumToItems(StoreStatus);
});

const showAction = () => {
  showActionTab.value = !showActionTab.value;
};
const filteredStatus: any = computed(() => {
  return statusQuery.value === ""
    ? StoreStatuses.value
    : StoreStatuses.value.filter((status: any) => {
        return status.Value.toLowerCase()
          .replace(/-|\s+/g, "")
          .includes(statusQuery.value.toLowerCase().replace(/-|\s+/g, ""));
      });
});

const fetchAllCategories = () => {
  categoryservice
    .getAll(new CategoryFilterEntity({ Limit: 100000 }))
    .then((res) => {
      Categories.value = res.data.data;
      console.log("Categories", Categories.value);
    });
};

const updateStoreCommission = async () => {
  storeDetails.value.commission = commission.value;
  const response = await storeservice.updateCommission(
    storeDetails.value.id,
    storeDetails.value.commission
  );

  if (response.data.success) {
    notify({
      title: "Success",
      text: "Store commission updated successfully",
      type: "success",
    });
  } else {
    notify({
      title: "Error",
      text: "Something went wrong",
      type: "error",
    });
  }
};

const closeStatusOption = (id: number) => {
  selectedStatus.value[id] = { Id: null, Value: "" };
  statusQuery.value = "";
};

const getStores = async (filter?: StoreFilterEntity) => {
  const response = await storeservice.getAll(new StoreFilterEntity(filter));
  stores.value = response.data.data;
  console.log("stores Response", response.data.data);
};
const getStore = () => {
  console.log("All stores data", Stores.value);
  console.log("Router params", route.params.id);

  Stores.value?.forEach(async (store: StoreEntity) => {
    console.log("Store id", store.id, "Route id", route.params.id);
    if (store.id == route.params.id.toString().trim()) {
      console.log("Found store", store, "Route id", route.params.id);

      storeDetails.value = store;
      return;
    }
  });

  console.log("Params", route.params.id);
  console.log("Store details", storeDetails.value);
  // store.state.storeDetails = storeDetails.value;
  // try {
  //   store.commit("setStoreDetails", storeDetails.value);
  // } catch (error) {
  //   console.log("error updating store details", error);
  // }

  return storeDetails.value;
};

const updateAutoOpenClose = async () => {
  try {
    await storeservice.updateStore(
      { autoOpenClose: storeDetails.value.autoOpenClose },
      route.params.id.toString()
    );

    const id = Date.now();
    notify({
      id,
      type: "success",
      duration: 2000,
      text: "updated",
    });
  } catch (err) {
    const id = Date.now();
    notify({
      id,
      type: "error",
      duration: 2000,
      text: err as any,
    });
  }
};
onMounted(async () => {
  loading.value = true;
  console.log("Router params", route.params.id);
  try {
    if (route.params.id === undefined) {
      await router.push("/stores");
      return;
    } else {
      await getStores();
      await getStore();
      await storeservice.getQr(QrType.STORE, route.params.id.toString()).then(
        (res) => {
          console.log("Qr code response", res);
          // var urlCreator = window.URL || window.webkitURL;
          // var imageUrl = urlCreator.createObjectURL(res.data);
          // console.log("Qr code", imageUrl);
          storeQrCode.value = res.data;
        },
        (err) => {
          console.log("Error", err);
        }
      );
    }

    commission.value = storeDetails.value?.commission;
    const categories: any = await categoryservice.getAll();
    console.log("Categories", categories);
    console.log("Store details", storeDetails.value);

    storeStatuses.forEach((status: any) => {
      if (status.id === storeDetails.value?.status) {
        storeDetails.value.status = status;
        storeStatus.value = status;
      }
    });

    if (storeDetails.value?.storeCategoryId) {
      storeDetails.value.storeCategoryId?.forEach((id: string) => {
        categories.data?.data.filter((category: any) => {
          if (category.id === storeDetails.value.category?.id) {
            storeSubCategories.value = category?.storeCategory;
          }
        });
      });
      storeDetails.value.logoImage = await getSignedUrl(
        storeDetails.value.logoImage
      );
      storeDetails.value.coverImage.forEach(
        async (image: any, index: number) => {
          console.log("Unsigned cover image", image);
          storeDetails.value.coverImage[index] = await getSignedUrl(image);
          console.log("Signed cover image", image);
        }
      );
    }
  } catch (error) {
    console.log("Error ", error);
    loading.value = false;
  }
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (loading.value)
    ? (_openBlock(), _createBlock(Loader, { key: 0 }))
    : (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(storeDetails.value?.name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/stores",
              class: "button-back button-light"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("input", {
                  type: "checkbox",
                  id: "isActive",
                  class: "hidden",
                  checked: storeDetails.value?.isActive,
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateStoreStatus && _ctx.updateStoreStatus(...args)))
                }, null, 40, _hoisted_11),
                _hoisted_12
              ]),
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("input", {
                    class: "appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-[#ed5151] checked:border-[#ed5151] focus:outline-none transition duration-200 float-left cursor-pointer",
                    type: "checkbox",
                    value: "",
                    id: "flexCheckChecked",
                    checked: storeDetails.value?.autoOpenClose,
                    onChange: updateAutoOpenClose
                  }, null, 40, _hoisted_16)
                ]),
                _hoisted_17
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_router_link, {
              to: `/store/${_unref(route).params?.id}/edit`,
              class: "button-light"
            }, {
              default: _withCtx(() => [
                _hoisted_19,
                _hoisted_20
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: `/store/${_unref(route).params?.id}/product`,
              class: "button-light"
            }, {
              default: _withCtx(() => [
                _hoisted_21,
                _hoisted_22
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: `/store/${_unref(route).params?.id}/table`,
              class: "button-light"
            }, {
              default: _withCtx(() => [
                _hoisted_23,
                _hoisted_24
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: `/store/${_unref(route).params?.id}/member`,
              class: "button-light"
            }, {
              default: _withCtx(() => [
                _hoisted_25,
                _hoisted_26
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(storeDetails.value?.name), 1),
                  _hoisted_33
                ]),
                _createElementVNode("img", {
                  src: storeDetails.value?.coverImage[0] || '#',
                  class: "store-cover"
                }, null, 8, _hoisted_34),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("img", {
                    src: storeDetails.value?.logoImage || '#',
                    class: "store-logo"
                  }, null, 8, _hoisted_36),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("img", {
                      src: `${_unref(appUrl)}/qr/store/${_ctx.$route.params.id}` || '#',
                      type: "image/png",
                      class: "store-logo"
                    }, null, 8, _hoisted_38)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    (storeDetails.value?.workingHours?.monday.enable)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(storeDetails.value?.workingHours?.monday.from) + " - " + _toDisplayString(storeDetails.value?.workingHours?.monday.to), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_45, "Closed"))
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    (storeDetails.value?.workingHours?.tuesday.enable)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(storeDetails.value?.workingHours?.tuesday.from) + " - " + _toDisplayString(storeDetails.value?.workingHours?.tuesday.to), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_49, "Closed"))
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    (storeDetails.value?.workingHours?.wednesday.enable)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(storeDetails.value?.workingHours?.wednesday.from) + " - " + _toDisplayString(storeDetails.value?.workingHours?.wednesday.to), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_53, "Closed"))
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    (storeDetails.value?.workingHours?.thursday.enable)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(storeDetails.value?.workingHours?.thursday.from) + " - " + _toDisplayString(storeDetails.value?.workingHours?.thursday.to), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_57, "Closed"))
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _hoisted_59,
                    (storeDetails.value?.workingHours?.friday.enable)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(storeDetails.value?.workingHours?.friday.from) + " - " + _toDisplayString(storeDetails.value?.workingHours?.friday.to), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_61, "Closed"))
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _hoisted_63,
                    (storeDetails.value?.workingHours?.saturday.enable)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString(storeDetails.value?.workingHours?.saturday.from) + " - " + _toDisplayString(storeDetails.value?.workingHours?.saturday.to), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_65, "Closed"))
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    (storeDetails.value?.workingHours?.sunday.enable)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_68, _toDisplayString(storeDetails.value?.workingHours?.sunday.from) + " - " + _toDisplayString(storeDetails.value?.workingHours?.sunday.to), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_69, "Closed"))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_70,
                  (storeDetails.value?.address == null)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_71, [
                        _hoisted_72,
                        _hoisted_73,
                        _createTextVNode(_toDisplayString(storeDetails.value?.phone), 1),
                        _hoisted_74,
                        _createTextVNode(_toDisplayString(storeDetails.value?.email), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_75, [
                        _createTextVNode(_toDisplayString(storeDetails.value?.address?.street), 1),
                        _hoisted_76,
                        _createTextVNode(" " + _toDisplayString(storeDetails.value?.address?.zipCode) + ", " + _toDisplayString(storeDetails.value?.address?.city) + ", " + _toDisplayString(storeDetails.value?.address?.country), 1),
                        _hoisted_77,
                        _createTextVNode(" " + _toDisplayString(storeDetails.value?.phone), 1),
                        _hoisted_78,
                        _createTextVNode(" " + _toDisplayString(storeDetails.value?.email), 1)
                      ])),
                  _hoisted_79
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", null, [
                  _hoisted_81,
                  _createElementVNode("div", _hoisted_82, [
                    _hoisted_83,
                    _createElementVNode("p", _hoisted_84, _toDisplayString(storeDetails.value?.minOrder) + " €", 1)
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _hoisted_86,
                    _createElementVNode("p", _hoisted_87, _toDisplayString(storeDetails.value?.deliveryCost) + " €", 1)
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _hoisted_89,
                    _createElementVNode("p", _hoisted_90, _toDisplayString(storeDetails.value?.deliveryTime) + " min", 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_91,
                  _createElementVNode("p", _hoisted_92, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storeDetails.value?.deliveryType, (type, index) => {
                      return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(type) + " " + _toDisplayString(index !== storeDetails.value?.deliveryType?.length - 1 ? ", " : ""), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_93,
                  _createElementVNode("p", _hoisted_94, _toDisplayString(storeDetails.value?.category?.name), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_95,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storeSubCategories.value, (subCategory, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "text",
                      key: index
                    }, _toDisplayString(subCategory.name.trim()) + " " + _toDisplayString(storeSubCategories.value?.length - 1 !== index ? ", " : ""), 1))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_96, [
              _hoisted_97,
              _createElementVNode("p", _hoisted_98, _toDisplayString(storeDetails.value?.description), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_99, [
            _hoisted_100,
            _createElementVNode("div", _hoisted_101, [
              _hoisted_102,
              _createVNode(AutoComplete, {
                class: "w-full sm:w-72",
                value: storeStatus.value,
                items: _unref(storeStatuses),
                "track-by": "value",
                "return-by": "value",
                "filter-by": "value",
                placeholder: "Status",
                "model-value": storeStatus.value,
                "show-close": true,
                onSubmit: _cache[1] || (_cache[1] = 
              (value) => {
                storeDetails.value.status = value;
              }
            )
              }, null, 8, ["value", "items", "model-value"])
            ]),
            _createElementVNode("div", _hoisted_103, [
              _hoisted_104,
              _createElementVNode("input", {
                type: "text",
                class: "form-field text-center w-full sm:w-72",
                value: `${storeDetails.value?.commission?.delivery || 0}%`,
                onChange: _cache[2] || (_cache[2] = 
              (value) => {
                commission.value.delivery = parseInt(value.target.value.split('%')[0]);
              }
            )
              }, null, 40, _hoisted_105)
            ]),
            _createElementVNode("div", _hoisted_106, [
              _hoisted_107,
              _createElementVNode("input", {
                type: "text",
                class: "form-field text-center w-full sm:w-72",
                value: `${storeDetails.value?.commission?.pickup || 0}%`,
                onChange: _cache[3] || (_cache[3] = 
              (value) => {
                commission.value.pickup = parseInt(value.target.value.split('%')[0]);
              }
            )
              }, null, 40, _hoisted_108)
            ]),
            _createElementVNode("div", _hoisted_109, [
              _hoisted_110,
              _createElementVNode("input", {
                type: "text",
                class: "form-field text-center w-full sm:w-72",
                value: `${storeDetails.value?.commission?.inStore || 0}%`,
                onChange: _cache[4] || (_cache[4] = 
              (value) => {
                commission.value.inStore = parseInt(value.target.value.split('%')[0]);
              }
            )
              }, null, 40, _hoisted_111)
            ]),
            _createElementVNode("div", { class: "flex justify-end" }, [
              _createElementVNode("div", {
                class: "button-light",
                onClick: updateStoreCommission
              }, _hoisted_113)
            ])
          ])
        ])
      ]))
}
}

})